import { useLang } from "@/i18n";

export default function Marquee() {
  const { t } = useLang();
  const items = [...t.marquee, ...t.marquee];

  return (
    <div data-testid="editorial-marquee" className="overflow-hidden border-y border-[#0E1B2A]/8 bg-[#F3EFEA] py-5">
      <div className="marquee-track flex w-max items-center">
        {items.map((item, i) => (
          <span key={i} className="flex items-center whitespace-nowrap">
            <span className="font-serif text-xl sm:text-2xl italic text-[#0E1B2A]/55 px-6">{item}</span>
            <span className="text-[#C87A57] text-lg">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
